import { ConversationDetails } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "../useChatApi";

export function useChatGlobalConversation(
  options?: UseQueryOptions<ConversationDetails>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["global-conversation"],
    queryFn: async () => {
      const { data } = await api.getGlobalConversation();
      return data;
    },
    ...options,
    refetchInterval: 5000,
  });
}
